// extracted by mini-css-extract-plugin
module.exports = {"Spinner":"Spinner_Spinner__34W5w","isActive":"Spinner_isActive__3NJtO","vertical":"Spinner_vertical__2L9W7"};